import type { NavLink } from '@/types'

export const navLinks: NavLink[] = [
    { label: "Violências", href: '/violencias' },
    { label: "Ajuda", href: '/ajuda' },
    { label: "Guias", href: '/guias' },
    { label: "Vozes", href: '/vozes' },
    { label: "Sobre", href: '/sobre' },
    { label: "Contato", href: '/contato' }
]
